export const buildLineItemsFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_name',
        label: 'Venue Name',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
    ],
  },
  {
    id: 'event',
    label: 'Event',
    filters: [
      {
        id: 'event_name',
        label: 'Event Name',
        type: 'search',
        options: (filterOptions.event_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
    ],
  },
  {
    id: 'line_item_details',
    label: 'Line Item Details',
    filters: [
      {
        id: 'finance_category',
        label: 'Category',
        type: 'checkbox',
        options: (filterOptions.finance_category_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
      {
        id: 'paid',
        label: 'Paid',
        type: 'checkbox',
        options: [
          { value: 'Paid', label: 'Paid' },
          { value: 'Not Paid', label: 'Not Paid' },
        ],
      },
      {
        id: 'type',
        label: 'Type',
        type: 'checkbox',
        options: [
          { value: 'Income', label: 'Income' },
          { value: 'Expense', label: 'Expense' },
        ],
      },
    ],
  },
];
